module.exports = __webpack_public_path__ + "img/de_cef_grau.bcd496ac.png";